import { LayoutHOC } from 'base/ui/layout/layout';
import createStockReceiving from './StockReceiving';

export const createStockReceivingPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createStockReceiving());
};